module.exports = __webpack_public_path__ + "media/images/dummy_code-cd15e6a9aa8bd386a64e41a44e2b78a2.jpg";